export const HOME_ROOT = ".smc/root";

